import { Link } from 'react-router-dom'
import './Placeholder.css'

/**
 * A destination the rail names but this issue does not build.
 *
 * Deliberately explicit. A rail item that routes to an empty page is
 * indistinguishable from one that is broken, and "not built yet" is
 * first-class information — the same posture the backend's release notes take
 * about half-wired work.
 */
export function Placeholder({ title }: { title: string }) {
  return (
    <section className="placeholder">
      <div className="placeholder__card">
        <span className="placeholder__eyebrow">Not built yet</span>
        <h1 className="placeholder__title">{title}</h1>
        <p className="placeholder__body">
          {title} has no design yet — it is named in the rail and nothing more. It lands in its own
          issue rather than as a blank page here, because a rail item that goes nowhere silently is
          indistinguishable from a broken one.
        </p>
        {/*
          The one thing a customer can actually do from here. Without it the page
          is a dead end that says so, which is honest and still a dead end.
        */}
        <Link className="placeholder__link" to="/balances">
          Go to Balances
        </Link>
      </div>
    </section>
  )
}
